export const terms = [
  {
    id: 1,
    label: '서비스 이용약관 동의 (필수)',
    required: true,
    file: 'service'
  },
  {
    id: 2,
    label: '개인정보 수집 및 이용동의 (필수)',
    required: true,
    file: 'privacy',
  },
  {
    id: 3,
    label: '광고성 정보 수신동의 (선택)',
    required: false,
    file: 'commercial'
  },
]